export default __webpack_public_path__ + "static/media/Panoptic Pirate Ring.67a210b2.jpg";